module.exports = __webpack_public_path__ + "img/star.43ca1f0f.svg";